import { EventListeners, MinzeElement } from 'minze'
import { MODALS } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'

export interface LvcPartnerSignupModalWrapper {}

export class LvcPartnerSignupModalWrapper extends MinzeElement {
  modalId = MODALS.PARTNER_SIGNUP_MODAL

  onReady(): void | Promise<void> {}

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goToLastPage()
  }

  html = () => `
    <lvc-modal is-fullscreen-modal-scrollable="true" background="linear-gradient(to top left, #42f7a3, rgba(255, 153, 150, 0), #8997ff), linear-gradient(to top right, #b0dee2,rgba(255, 153, 150, 0), #01c0b6) rgba(70,205,209,255)" is-fixed="false" modal-id="${this.modalId}" narrow="true">
      <div slot="lvc-modal-content">
        <lvc-partner-signup-modal-content></lvc-partner-signup-modal-content>
      </div>  
    </lvc-modal>
  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
